// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserUserSurgeryProfile_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10ZM12 12C15.3137 12 18 9.31371 18 6C18 2.68629 15.3137 0 12 0C8.68629 0 6 2.68629 6 6C6 9.31371 8.68629 12 12 12ZM18 12.5C18 13.3284 18.6716 14 19.5 14C20.3284 14 21 13.3284 21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5ZM19.5 19C18.6716 19 18 18.3284 18 17.5C18 16.6716 18.6716 16 19.5 16C20.3284 16 21 16.6716 21 17.5C21 18.3284 20.3284 19 19.5 19ZM18 22.5C18 23.3284 18.6716 24 19.5 24C20.3284 24 21 23.3284 21 22.5C21 21.6716 20.3284 21 19.5 21C18.6716 21 18 21.6716 18 22.5ZM16.0244 17.0844C16.1071 16.3859 16.3954 15.7504 16.8272 15.2402C15.3961 14.4498 13.7506 14 12 14C6.47715 14 2 18.4772 2 24H4C4 19.5817 7.58172 16 12 16C13.4672 16 14.8422 16.395 16.0244 17.0844Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserUserSurgeryProfile is a generated icon component.
 */
let IconUserUserSurgeryProfile = IconUserUserSurgeryProfile_1 = class IconUserUserSurgeryProfile extends IconBaseElement {
    render() {
        return html `${IconUserUserSurgeryProfile_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserUserSurgeryProfile.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserUserSurgeryProfile = IconUserUserSurgeryProfile_1 = __decorate([
    customElement('zui-icon-user-user-surgery-profile')
], IconUserUserSurgeryProfile);
export { IconUserUserSurgeryProfile };
